google.maps.event.addDomListener(window, 'load', init);

function init() {
	var snazzyStyles = [{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"lightness":"27"}]},{"featureType":"landscape.natural.terrain","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.attraction","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.medical","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"simplified"},{"lightness":"24"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.place_of_worship","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.school","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.sports_complex","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"simplified"},{"lightness":"0"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"lightness":"0"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"lightness":"0"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"saturation":"0"},{"lightness":"0"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"lightness":"0"}]},{"featureType":"road.highway.controlled_access","elementType":"labels","stylers":[{"lightness":"0"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"lightness":"66"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"lightness":"47"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.icon","stylers":[{"saturation":"-100"}]},{"featureType":"transit.line","elementType":"labels.icon","stylers":[{"saturation":"-100"}]},{"featureType":"transit.station","elementType":"labels.text","stylers":[{"visibility":"simplified"},{"color":"#787878"}]},{"featureType":"transit.station","elementType":"labels.icon","stylers":[{"saturation":"-100"},{"visibility":"simplified"}]},{"featureType":"water","elementType":"all","stylers":[{"lightness":"39"}]}];

	if(jQuery('#map').length){ 
		var markers = [];
		var centerLat = 0, centerLng = 0;

		var $pins = $('#map .map-pin');
		$pins.each(function() {
			var location = new google.maps.LatLng($(this).data('latitude'), $(this).data('longitude'));
			var icon = 'https://banyanplace.ivystreet.onstage.yourtemporary.com/wp-content/themes/growland/images/map-marker.svg';
			console.log(icon);
			centerLat += location.lat();
			centerLng += location.lng();

			markers.push({
				'location': location,
				'icon': icon,
				'parent': $(this).data('parent'),
			});
		});

		var center = new google.maps.LatLng(centerLat / $pins.length, centerLng / $pins.length);

		var mapOptions = { 
			zoom: 15,
			scrollwheel: true,
			zoomControl: false,
			draggable: false,
			streetViewControl: false,
			mapTypeControl: false,
			center: center,
			styles: [{
		        "featureType": "all",
			        "elementType": "labels.text.fill",
			        "stylers": [
			            {
			                "saturation": "0"
			            },
			            {
			                "color": "#808285"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "all",
			        "elementType": "labels.text.stroke",
			        "stylers": [
			            {
			                "visibility": "on"
			            },
			            {
			                "color": "#ffffff"
			            },
			            {
			                "lightness": 16
			            }
			        ]
			    },
			    {
			        "featureType": "all",
			        "elementType": "labels.icon",
			        "stylers": [
			            {
			                "visibility": "off"
			            }
			        ]
			    },
			    {
			        "featureType": "administrative",
			        "elementType": "geometry.fill",
			        "stylers": [
			            {
			                "color": "#f8ede8"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "administrative",
			        "elementType": "geometry.stroke",
			        "stylers": [
			            {
			                "color": "#f8ede8"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "weight": 1.2
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "landscape",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#f8ede8"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "poi",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#feeee9"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1.00"
			            }
			        ]
			    },
			    {
			        "featureType": "poi.park",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#fac2bc"
			            },
			            {
			                "lightness": 21
			            }
			        ]
			    },
			    {
			        "featureType": "road.highway",
			        "elementType": "geometry.fill",
			        "stylers": [
			            {
			                "color": "#f05664"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "road.highway",
			        "elementType": "geometry.stroke",
			        "stylers": [
			            {
			                "color": "#f05664"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "weight": 0.2
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "road.arterial",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#ffffff"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "road.local",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#ffffff"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "transit",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#231f20"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    },
			    {
			        "featureType": "transit.station.airport",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#ff7e8b"
			            },
			            {
			                "lightness": "20"
			            },
			            {
			                "gamma": "1.00"
			            }
			        ]
			    },
			    {
			        "featureType": "water",
			        "elementType": "geometry",
			        "stylers": [
			            {
			                "color": "#abe1fa"
			            },
			            {
			                "lightness": "0"
			            },
			            {
			                "gamma": "1"
			            }
			        ]
			    }
			]

		};

		var mapElement = document.getElementById('map');
		var map = new google.maps.Map(mapElement, mapOptions);

		for(var i in markers) {
			var marker = new google.maps.Marker({
				position: markers[i].location, 
				icon: markers[i].icon,
				map: map,
			});

			marker.addListener('click', function() {
				map.setCenter(this.position);
				map.setZoom(15);
			});

			$(markers[i].parent).prop('_marker', marker);
		}

		window.addEventListener('resize', function() {
			map.setCenter(center);
		});

		$('.tile.location').click(function() {
			var marker = $(this).prop('_marker');
			if(marker) {
				map.setCenter(marker.position);
				map.setZoom(15);
			}
		});
	}
}